import { ContactSelect } from './ContactSelect';
import { connect } from 'react-redux';
import {
  userDataSel,
  userActions,
  accountsIsPendingSel
} from 'src/store/modules/user';

const mapStateToProps = (state: any) => {
  return {
    userData: userDataSel(state),
    loading: accountsIsPendingSel(state)
  };
};

const mapDispatchToProps = (dispatch: any): IDispatchFromProps => ({
  getUserDetails: () => dispatch(userActions.getUserDetails())
});

export const pureComponent = ContactSelect;
export default connect(mapStateToProps, mapDispatchToProps)(ContactSelect);

interface IDispatchFromProps {
  getUserDetails(): void;
}
